import React from 'react';
import Icon from './Icon';
import Reveal from './Reveal';
import './Promo.css';

const FLOATERS = [
  { icon: 'package', style: { top: '12%', left: '8%' }, delay: '0s' },
  { icon: 'shoppingBag', style: { top: '65%', left: '14%' }, delay: '1.2s' },
  { icon: 'compass', style: { top: '20%', right: '10%' }, delay: '0.6s' },
  { icon: 'mapPin', style: { top: '68%', right: '9%' }, delay: '1.8s' },
];

export default function Promo() {
  return (
    <section className="promo">
      <div className="promo__glow" />
      {FLOATERS.map((f, i) => (
        <span className="promo__floater" style={{ ...f.style, animationDelay: f.delay }} key={i}>
          <Icon name={f.icon} size={22} />
        </span>
      ))}

      <div className="container promo__inner">
        <Reveal>
          <span className="eyebrow eyebrow--light">Advertisement</span>
        </Reveal>
        <Reveal delay={80}>
          <h2 className="promo__title">Everything you need, moving in one direction.</h2>
        </Reveal>
        <Reveal delay={140}>
          <p className="promo__text">
            Order food through BikesFood, groceries through BikesGroceries, send a package, move
            cargo, or run an errand. Riders earn on their schedule. Merchants sell without owning a
            fleet. One download puts all of it in your pocket.
          </p>
        </Reveal>

        <Reveal delay={200}>
          <div className="promo__ctas">
            <a href="#customer" className="btn btn--teal">
              <Icon name="shoppingBag" size={17} />
              Order Now
            </a>
            <a href="#business" className="btn btn--ghost">
              <Icon name="compass" size={17} />
              Ride With Us
            </a>
            <a href="#business" className="btn btn--amber">
              <Icon name="briefcase" size={17} />
              List Your Store
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
